import { createApp } from 'vue'
import App from './App.vue'
import Api from '@/api';
import store from './store'
import router from './router'
import VueGtm from 'vue-gtm'
import '@/assets/app.scss'
import '@/index.css'
import '@/assets/magazine.scss'
import '@/assets/font/fonts.css'
import 'font-awesome/css/font-awesome.css'
// import Vue3Lottie from 'vue3-lottie'
// import 'vue3-lottie/dist/style.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import moment from 'moment';
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
const app = createApp(App);
app.config.globalProperties.$request = Api;
app.config.globalProperties.$moment = moment
app.use(VueAwesomeSwiper)
app.use(VueSweetalert2)
import { createI18n } from "vue-i18n";
import zh from './i18n/zh.json'
import en from './i18n/en.json'

let locale = 'en'
const langJudge = navigator.userLanguage || navigator.language

if (langJudge.includes('zh')) {
  locale = 'zh'
  store.dispatch('setLang', 'zh')
} else {
  locale = 'en'
  store.dispatch('setLang', 'en')
}

const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'en',
  messages: {
    'zh': zh,
    'en': en
  }
})

app.use(VueGtm, {
  id: 'GTM-KT6QNHX',
  enabled: process.env.NODE_ENV === 'production',
  defer: false,
  debug: true,
  loadScript: true,
  vueRouter: router,
  ignoredViews: ['index', 'adminlogin', 'list', 'edit']
})
app.use(i18n)
app.use(store)
app.use(router)
app.component('v-select', vSelect);
app.use(Toast, {
  position: 'top-right',
  timeout: 1000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
})
app.config.globalProperties.$moment = moment

app.mount('#app')
